
import { PostItem } from 'hc-entities';
import {
    GET_POSTS,
    GET_POST
} from '../actions/feedActions';

const initialState: FeedReducerState = {
    posts: [],
    post: undefined
}

const feedReducer = (state = initialState, action: any) => {
    switch (action.type) {
        case GET_POSTS:
            return {
                ...state,
                posts: action.value
            }

        case GET_POST:
            return {
                ...state,
                post: action.value
            }
        default:
            return state;
    }
}

export interface FeedReducerState {
    posts: PostItem[],
    post: PostItem | undefined
}


export default feedReducer;